import i18n from 'i18next';

export default function formattedAmount(amount, currency) {
    try {
        return new Intl.NumberFormat(i18n.language.replace("_", "-"), { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(amount)
    } catch (error) {
        console.error(error);
        return "";
    }
}
